import Logo from '../ui_icons/logo.svg'
import CloseIcon from '../ui_icons/close.svg'
import HelpIcon from '../ui_icons/help.svg'

export default function Help({ modal, setModal }) {
  const HelpModal = ({ visible }) => (
    <div
      id="modal-wrapper"
      className={visible ? 'visible' : 'hidden'}
      onClick={() => setModal(false)}
    >
      <div id="modal" onClick={e => e.stopPropagation()}>
        <div id="modal-content">
          <div id="modal-header">
            <img id="logo" src={Logo} alt="TED Logo" />
            <h2>Help</h2>
            <button onClick={() => setModal(false)}>
              <img src={CloseIcon} alt="Close" />
            </button>
          </div>
          <p>
            Thanks for using the TED Stage Notifier (v
            {process.env.REACT_APP_VERSION}), a tool for communicating with TED
            Speakers while they're on stage.
          </p>
          <h4>How it works</h4>
          <p>
            From the dashboard, you can type a message (up to 50 characters) and
            once you're ready, send it to the stage. You can also clear the
            current on stage message, or "flash" the screen to get the speaker's
            attention.
          </p>
          <br />
          <p>
            From the Stage Preview panel, use the full screen button in the top
            right to enter Stage view. The header and footer will automatically
            hide after 3 seconds of inactivity to display only the active
            message.
          </p>
          <h4>Need help?</h4>
          <p>
            If you spot a bug or just have questions, please email us at{' '}
            <a href="mailto:contact@ted.com">contact@ted.com</a>.
          </p>
        </div>
      </div>
    </div>
  )

  return (
    <div id="help">
      <button
        id="help-button"
        onClick={() => setModal('help')}
        data-mixpanel-component="help-button"
      >
        <img src={HelpIcon} alt="Settings" />
      </button>
      <HelpModal visible={modal === 'help'} />
    </div>
  )
}
